import {UserSummary} from "@app/shared/classes/user";

export class OrgStructureSummary {
  id: number;
  parentId: number;

  users: UserSummary[];

  name: string;
  description: string;
  depth: number;
  orgId: number;
  manager: UserSummary;
  essOwner: number;
  essOwnerName: number;
}
